import { Pipe, PipeTransform } from '@angular/core';
import { AcceptEnum } from '@commons/file-picker/models/accept.enum';

@Pipe({ name: 'fileType' })
export class FileTypePipe implements PipeTransform {
  transform(types: AcceptEnum[] | string[], separator = ', '): string {
    const result: string[] = [];
    const typesToCheck = Array.isArray(types) ? types : [types];

    for (const type of typesToCheck) {
      switch (type) {
        case AcceptEnum.JPG:
          result.push('JP(E)G');
          break;

        case AcceptEnum.PNG:
          result.push('PNG');
          break;

        case AcceptEnum.SVG:
          result.push('SVG');
          break;

        case AcceptEnum.PDF:
          result.push('PDF');
          break;

        default:
          break;
      }
    }

    return result.join(separator);
  }
}
